"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Rss.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Rss = function Rss(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 130.03 130.03"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "RSS Icon"), _react2.default.createElement("path", {
    className: "rss",
    d: "M29.47 100.51a17.1 17.1 0 0 1 0 24.31 17.29 17.29 0 0 1-24.41 0 17.12 17.12 0 0 1 0-24.32 17.25 17.25 0 0 1 24.41 0zm0 0zm-24.4 24.32zM0 44.22V69a60.56 60.56 0 0 1 43 17.91A60.7 60.7 0 0 1 60.87 130H85.8a85.61 85.61 0 0 0-25.17-60.6A85.49 85.49 0 0 0 0 44.22zM.06 0v24.82A105.33 105.33 0 0 1 105.14 130H130a129.67 129.67 0 0 0-38.1-91.85A129.56 129.56 0 0 0 .06 0zm0 0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Rss;